export const brokenPartStatusId = 1
